import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/common/Dialog.js";
import React, { Component } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

/**
 * Utilizes the Dialog components from material-UI to create a generic
 * dialog component for displaying messages to users.
 *
 * To Use:
 *
 * Paste this into the return value of the component render() method:
 *                 <Dialog ref={this.setDialogRef}/>
 * Add these lines to the constructor method:
 *                 this.dialogRef = null;
 *                 this.setDialogRef = element => {
 *                     this.dialogRef = element;
 *                 }
 * Call with Util.createDialog(title, description, ref) where ref is this.dialogRef
 */
class AlertDialog extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleClickOpen", () => {
      this.setState({
        open: true
      });
    });
    _defineProperty(this, "handleClose", () => {
      this.setState({
        open: false
      });
    });
    this.state = {
      open: false,
      title: props.title != null ? props.title : null,
      description: props.description != null ? props.description : null
    };
  }
  setDescription(description) {
    this.state.description = description;
  }
  setTitle(title) {
    this.state.title = title;
  }
  render() {
    if (this.state.description === null) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Dialog, {
      open: this.state.open,
      onClose: this.handleClose,
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 17
      }
    }, this.state.title != null && /*#__PURE__*/React.createElement(DialogTitle, {
      id: "alert-dialog-title",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 50
      }
    }, this.state.title), /*#__PURE__*/React.createElement(DialogContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(DialogContentText, {
      id: "alert-dialog-description",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 25
      }
    }, this.state.description)), /*#__PURE__*/React.createElement(DialogActions, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        this.handleClose();
      },
      color: "primary",
      autoFocus: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 25
      }
    }, "Okay"))));
  }
}
export default AlertDialog;